export const BUDGET_LOADING = "BUDGET_LOADING";
export const BUDGET_RESET = "BUDGET_RESET";
export const GET_BUDGET = "GET_BUDGET";
export const GET_BUDGET_SUCCESS = "GET_BUDGET_SUCCESS";
export const GET_BUDGET_FAIL = "GET_BUDGET_FAIL";
export const DELETE_BUDGET = "DELETE_BUDGET"
export const DELETE_BUDGET_SUCCESS = "DELETE_BUDGET_SUCCESS"
export const DELETE_BUDGET_FAIL = "DELETE_BUDGET_FAIL"
export const UPDATE_BUDGET = "UPDATE_BUDGET"
export const UPDATE_BUDGET_SUCCESS = "UPDATE_BUDGET_SUCCESS"
export const UPDATE_BUDGET_FAIL = "UPDATE_BUDGET_FAIL"
export const ADD_NEW_BUDGET = "ADD_NEW_BUDGET"
export const ADD_BUDGET_SUCCESS = "ADD_BUDGET_SUCCESS"
export const ADD_BUDGET_FAIL = "ADD_BUDGET_FAIL"